import {Component, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {map, Observable, Subscription} from 'rxjs';
import {StorageService} from 'src/app/services/storage.service';
import {FieldConfig, FieldType} from 'src/app/shared/components/dynamic-forms-components/field.interface';
import {enumToObjectArray} from 'src/app/shared/functions/functions';
import * as ComplaintFeedbackActions from "src/app/store/entities/feedback/feedback.actions"
import {
  citizenGetAllFeedbackCategories
} from 'src/app/store/entities/citizens/citizen-get-all-feedback-categories/citizen-get-all-feedback-categories.actions';
import {
  selectModCitizenServicesCategories
} from 'src/app/store/entities/citizens/citizen-get-all-feedback-categories/citizen-get-all-feedback-categories.selectors';
import {createFeedback} from 'src/app/store/entities/feedback/feedback.actions';
import {feedbackTypeEnum} from 'src/app/store/entities/feedback/feedback.model';
import {AppState} from 'src/app/store/reducers';
import {Actions, ofType} from "@ngrx/effects";
import {DynamicFormService} from "../dynamic-forms-components/dynamic-form.service";
import {Service} from "../../../store/entities/service-management/service/service.model";
import {getAllService} from "../../../store/entities/service-management/service/service.actions";
import {selectModifiedServicesById} from "../../../store/entities/service-management/service/service.selectors";
import {
  selectModifiedCitizensByServiceUniqueId
} from "../../../store/entities/citizens/citizens-services/citizens-services.selectors";
import {CitizensServices} from "../../../store/entities/citizens/citizens-services/citizens-services.model";
import {Regions} from "../../../store/entities/locations/regions/regions.model";
import {Districts} from "../../../store/entities/locations/districts/districts.model";
import {Wards} from "../../../store/entities/locations/wards/wards.model";
import {Streets} from "../../../store/entities/locations/streets/streets.model";
import {getAllRegions} from "../../../store/entities/locations/regions/regions.actions";
import {selectAllRegions, selectModifiedRegions} from "../../../store/entities/locations/regions/regions.selectors";
import {GET_ALL_REGIONS} from "../../../store/entities/locations/regions/regions.graphql";
import {selectAllDistricts} from "../../../store/entities/locations/districts/districts.selectors";
import {getAllDistricts} from "../../../store/entities/locations/districts/districts.actions";
import {getAllWards} from "../../../store/entities/locations/wards/wards.actions";
import {selectAllWards} from "../../../store/entities/locations/wards/wards.selectors";
import {getAllStreets} from "../../../store/entities/locations/streets/streets.actions";
import {selectAllStreets} from "../../../store/entities/locations/streets/streets.selectors";
import {SettingsService} from "../../../services/settings.service";
import {TrackNumberPopupComponent} from "./track-number-popup/track-number-popup.component";

@Component({
  selector: 'app-feedback-window',
  templateUrl: './feedback-window.component.html',
  styleUrls: ['./feedback-window.component.scss']
})
export class FeedbackWindowComponent implements OnInit, OnDestroy {
  @Input() serviceUniqueId: string;
  saveLoading: boolean;
  subscription$: Subscription = new Subscription();
  form: FormGroup;
  fields: FieldConfig[] = this.formFields();
  actions$ = inject(Actions);
  selectedService: Observable<CitizensServices>
  serviceProvider: string

  regions:Observable< Regions[]>;
  districts: Observable<Districts[]>;
  wards: Observable<Wards[]>;
  streets: Observable<Streets[]>;


  constructor(
    private dynamicFormService: DynamicFormService,
    private store: Store<AppState>,
    private storageService: StorageService,
    private settingsService: SettingsService
  ) {

  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  ngOnInit(): void {
    this.store.dispatch(citizenGetAllFeedbackCategories())
    this.store.dispatch(getAllRegions())
    this.form = this.dynamicFormService.createControl(this.fields, {});
    this.listenToActions();

    this.selectedService = this.store.pipe(select(selectModifiedCitizensByServiceUniqueId(this.serviceUniqueId)))
    this.subscription$.add(this.selectedService.subscribe((item) => {
      if (item) {
        this.serviceProvider = item?.serviceProvider?.institutionUniqueId
      }
    }))

    this.regions = this.store.select(selectAllRegions)
    this.regions.subscribe((items) => {
      if (items) {
        // this.form.
      }
    })

  }

  getDistricts() {
    this.fields = this.fields.map(field => {
      if (field.key === 'districtUniqueId') {
        // this.subscription.add(
          this.store.select(selectAllDistricts).subscribe((districts: Districts[]) => {
            field.options = districts.map((district: Districts) => ({name: district?.districName, value: district?.districUniqueId}));
          })
        // )
      }
      return field;
    });
  }

  getWards() {
    this.fields = this.fields.map(field => {
      if (field.key === 'wardUniqueId') {
        // this.subscription.add(
        this.store.select(selectAllWards).subscribe((wards: Wards[]) => {
          field.options = wards.map((ward: Wards) => ({name: ward?.wardName, value: ward?.wardUniqueId}));
        })
        // )
      }
      return field;
    });
  }

  getStreets() {
    this.fields = this.fields.map(field => {
      if (field.key === 'streetUniqueId') {
        // this.subscription.add(
        this.store.select(selectAllStreets).subscribe((streets: Streets[]) => {
          field.options = streets.map((street: Streets) => ({name: street?.streetName, value: street?.streetUniqueId}));
        })
        // )
      }
      return field;
    });
  }

  getSelected(event: any) {
    if (event.key === 'regionUniqueId') {
      this.store.dispatch(getAllDistricts({regionalUniqueId: event?.value}));
      this.getDistricts();
    }
    if (event.key === 'districtUniqueId') {
      this.store.dispatch(getAllWards({districUniqueId: event?.value}));
      this.getWards();
    }
    if (event.key === 'wardUniqueId') {
      this.store.dispatch(getAllStreets({wardUniqueId: event?.value}));
      this.getStreets();
    }
  }


  async submitForm(formData: any) {
    const isAnonymous = formData?.isAnonymous;

    if (isAnonymous) {
      delete formData.firstName;
      delete formData.lastName;
      delete formData.phoneNo;
      // delete formData.country;
      // delete formData.regionUniqueId;
      // delete formData.districtUniqueId;
      // delete formData.wardUniqueId;
      // delete formData.streetUniqueId;
      delete formData.gender;
      delete formData.age;
      delete formData.isPublicServant;
      delete formData.checkNo;
      delete formData.servantType;
      delete formData.designation;
    }
    delete formData.isAnonymous;

    let dto = {
      ...formData,
      feedbackComplaintEvidences: [{
        name: formData.feedbackComplaintEvidences?.fileName,
        attachmentPath: formData?.feedbackComplaintEvidences?.fileUrl,
      }],
      serviceUniqueId: this.serviceUniqueId,
    }

    this.store.dispatch(createFeedback({input: dto}))

    this.form?.reset();
  }

  formFields(): FieldConfig[] {
    return [
      {
        type: FieldType.radiobutton,
        label: 'Je, ungependa kutoa mrejesho bila kujitambulisha?',
        key: 'isAnonymous',
        options: [
          { name: 'Ndiyo', value: true },
          { name: 'Hapana', value: false }
        ],
        validations: [{ message: 'Tafadhali chagua jibu', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-12'
      },
      {
        type: FieldType.input,
        label: 'Kichwa cha Mrejesho',
        key: 'title',
        validations: [{ message: 'Tafadhali jaza sehemu hii', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-6'
      },
      {
        type: FieldType.select,
        label: 'Aina ya Mrejesho',
        key: 'feedbackType',
        options: [
          { name: "Malalamiko", value: "COMPLAINT" },
          { name: "Mapendekezo", value: "SUGGESTIONS" },
          { name: "Pongezi", value: "COMPLIMENTS" },
          { name: "Maswali", value: "INQUIRIES" },
        ],
        validations: [{ message: 'Tafadhali chagua aina ya mrejesho', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-6'
      },
      {
        type: FieldType.textarea,
        label: 'Maelezo ya Mrejesho Wako',
        key: 'description',
        validations: [{ message: 'Sehemu hii ni lazima ijazwe', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-12'
      },
      {
        type: FieldType.textarea,
        label: 'Maoni kuhusu mrejesho wako',
        key: 'suggestions',
        showWhen: '{(isAnonymous)(==)(false)}',
        rowClass: 'col-span-12'
      },
      {
        type: FieldType.input,
        label: 'Jina la Kwanza',
        key: 'firstName',
        showWhen: '{(isAnonymous)(==)(false)}',
        validations: [{ message: 'Tafadhali jaza jina lako', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.input,
        label: 'Jina la Mwisho',
        key: 'lastName',
        showWhen: '{(isAnonymous)(==)(false)}',
        validations: [{ message: 'Tafadhali jaza jina lako la mwisho', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.input,
        label: 'Nchi',
        key: 'country',
        validations: [{ message: 'Tafadhali jaza nchi', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.paginatedselect,
        label: 'Mkoa',
        key: 'regionUniqueId',
        optionName: 'reginalName',
        optionValue: 'regionalUniqueId',
        query: GET_ALL_REGIONS,
        // showWhen: '{(isAnonymous)(==)(false)}',
        validations: [{ message: 'Tafadhali chagua mkoa', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.select,
        label: 'Wilaya',
        key: 'districtUniqueId',
        options: [],
        showWhen: '{(regionUniqueId)(!=)(null)}',
        validations: [{ message: 'Tafadhali chagua wilaya', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.select,
        label: 'Kata',
        key: 'wardUniqueId',
        options: [],
        showWhen: '{(districtUniqueId)(!=)(null)}',
        validations: [{ message: 'Tafadhali chagua kata', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.select,
        label: 'Mtaa',
        key: 'streetUniqueId',
        options: [],
        showWhen: '{(wardUniqueId)(!=)(null)}',
        validations: [{ message: 'Tafadhali chagua mtaa', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.input,
        label: 'Namba ya Simu',
        key: 'phoneNo',
        showWhen: '{(isAnonymous)(==)(false)}',
        showInputMask: true,
        mask: '000-000-000-000',
        validations: [{ message: 'Tafadhali jaza namba ya simu', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.radiobutton,
        label: 'Je! Ni mtumishi wa umma',
        key: 'isPublicServant',
        options: [
          { name: "Ndiyo", value: true },
          { name: "Hapana", value: false }
        ],
        showWhen: '{(isAnonymous)(==)(false)}',
        validations: [{ message: 'Tafadhali chagua', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.input,
        label: 'Namba ya Ukaguzi',
        key: 'checkNo',
        showWhen: '{(isPublicServant)(==)(true)}',
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.select,
        label: 'Aina ya Mtumishi',
        key: 'servantType',
        options: [
          { name: "Aliyeajiriwa", value: "EMPLOYED" },
          { name: "Mstaafu", value: "RETIRED" },
        ],
        showWhen: '{(isPublicServant)(==)(true)}',
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.input,
        label: 'Cheo',
        key: 'designation',
        showWhen: '{(isPublicServant)(==)(true)}',
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.select,
        label: 'Jinsia',
        key: 'gender',
        options: [
          { name: "Mwanaume", value: "MALE" },
          { name: "Mwanamke", value: "FEMALE" }
        ],
        showWhen: '{(isPublicServant)(==)(false)}',
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.input,
        inputType: 'number',
        label: 'Umri',
        key: 'age',
        showWhen: '{(isPublicServant)(==)(false)}',
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.radiobutton,
        label: 'Je una viambatanishi vyovyote vya ushahidi?',
        key: 'hasEvidence',
        options: [
          { name: "Ndiyo", value: true },
          { name: "Hapana", value: false }
        ],
        validations: [{ message: 'Tafadhali chagua', validator: Validators.required, name: 'required' }],
        rowClass: 'col-span-4'
      },
      {
        type: FieldType.attachment,
        label: "Viambatisho vya Ushahidi",
        uploadAttachment: true,
        showWhen: '{(hasEvidence)(==)(true)}',
        key: "feedbackComplaintEvidences",
        rowClass: 'col-span-12'
      },
      {
        type: FieldType.button,
        label: 'Tuma Mrejesho',
        rowClass: 'col-span-12'
      }
    ];
  }

  private listenToActions() {
    this.subscription$.add(
      this.actions$
        .pipe(ofType(ComplaintFeedbackActions.upsertFeedback))
        .subscribe((data) => {
          this.settingsService.openDialogModal({
            component: TrackNumberPopupComponent,
            data: {
              trackNumber: data?.feedback?.trackNumber
            }
          })
        })
    );
  }
}
